import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { SignUpForm } from '../sections/auth/signup';
import api from '../utils/api';

// // Example to get data from an endpoint called "/users"
// api.get('/users').then(response => {
//   console.log(response.data);
// });

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <>
      <Helmet>
        <title> Login </title>
      </Helmet>

      <StyledRoot>
        <img
          src='https://businessadvocacy.com.mx/wp-content/uploads/2022/09/cropped-logo_business-removebg-preview-1-1-239x300.png'
          alt='Logo Business Advocacy'
          style={{
            position: 'fixed',
            top: 16, // Para XS y por encima
            left: 16, // Para XS y por encima
            width: '32px', // 30% de 239px
            height: '50px', // 30% de 300px
            margin: '1em' // Añade un margen alrededor de la imagen
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Businessadvocacy
            </Typography>
            <img src="/assets/illustrations/illustration_login.png" alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Crea tu cuenta
            </Typography>

            <Typography variant="body2" sx={{ mb: 5 }}>
              ¿Tienes problemas para crear la cuenta? {''}
              <Link variant="subtitle2">Ayuda</Link>
            </Typography>

            <SignUpForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
